<template>
  <select-item :validator="validator"
    :items="countries"
    placeholder="Select a Country"
    placeholderEmpty="No countries found"
    :isLoading="isLoading" />
</template>

<script>
import SelectItem from './SelectItem.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SelectCountry',
  components: {
    SelectItem
  },
  props: {
    validator: Object
  },
  data() {
    return {
      isLoading: false
    }
  },
  created() {
    if (!this.countries) {
      this.fetchCountries();
    }
  },
  methods: {
    async fetchCountries() {
      this.isLoading = true;
      await this.$store.dispatch('organization/fetchCountries');
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('organization', ['countries'])
  }
}
</script>

